import sprint from 'sprint'

export default class Translator {
	static translations = {}

	static setTranslations(translations, group) {
		if(typeof group == null) {
			group = 'default';
		}

		if(Translator.translations[group] == null) {
			Translator.translations[group] = {};
		}

		Translator.translations[group] = Object.assign(Translator.translations[group], translations);
	}

	static translate(original_string, group) {
		if(typeof group === 'undefined') {
			group = 'default';
		}

		if(Translator.translations[group] == null) {
			console.log('Translation group does not exist: ' + group + ' : ' + original_string);
		} else if(Translator.translations[group][original_string] == null) {
			console.log('Translation does not exist in group: ' + group + ' : ' + original_string);
		}

		const translation = Translator.translations?.[group]?.[original_string];

		if(translation == null) {
			return original_string;
		}

		return translation;
	}

	static translateReplace(original_string, replace, group) {
		let translated = Translator.translate(original_string, group)
		return sprint(translated, ...replace);
	}

	static translateNumber(singular, plural, number, group) {
		if(number !== 0 && number <= 1 && number >= -1) {
			return this.translateReplace(singular, number.toString(), group)
		}

		return this.translateReplace(plural, number.toString(), group)
	}
}